import {
  GET_CONTENT_ERR,
  GET_CONTENT_REQ,
  GET_CONTENT_RES,
} from '../constants';
// ##### 25-01-10 Komarov
import { getUrl } from '../../helpers/crypto';
// ##### 25-03-28 Komarov
import { getSavingDataClient } from '../../helpers/saveData';
// ##### 25-04-30 Komarov
import { uniLog } from '../../../server/helpers/uniLog';

// console.log('[CONTENTRESPONCE]' , contentResponse)

// ##### 25-03-26 Komarov
export const getContent = (id, locale) => async dispatch => {
  dispatch({ type: GET_CONTENT_REQ });

  // ##### 25-01-10 Komarov
  const url = getUrl('content', `id=${id}&language=${locale}`);
  // ##### Komarov 2025-09-02
  uniLog(
    'content.js',
    'axios:src/Redux/actions/content.js:getContent, url:',
    url
  );

  // ##### 25-03-28 Komarov: запрашиваем у Сервера Сайта сохранение данных для запроса с текущими параметрами
  await getSavingDataClient({
    smartUrl: url,
    typeRes: GET_CONTENT_RES,
    typeErr: GET_CONTENT_ERR,
    dispatch,
  });
};
